module.exports = __webpack_public_path__ + "static/media/illustration.bb7938f1.svg";